export default __webpack_public_path__ + "static/media/Item Upload2.6312f5ff.svg";